<template>
  <!-- Modal -->
  <div
    class="modal fade"
    :id="p_id"
    data-backdrop="static"
    data-keyboard="false"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-scrollable modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">作业</h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div
          class="modal-body"
          style="min-height: 300px"
          @dragover.prevent
          @drop.prevent="handleDropUpload"
        >
          <!-- 空状态 -->
          <div
            class="my-5 d-flex flex-column align-items-center"
            v-if="0 === mg_assignmentAttachmentLinkList.length"
          >
            <img
              src="https://resources.pzacademy.com/image/class-ui/NoData.svg"
              width="150"
              style="opacity: 0.2"
            />
            <div class="text-secondary my-3">请上传你的作业</div>
          </div>
          <!-- 作业列表 -->
          <div
            class="list-group list-group-flush"
            v-if="mg_assignmentAttachmentLinkList.length"
          >
            <div
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
              :key="studentwork.fileUrl"
              v-for="(studentwork, idx) in mg_assignmentAttachmentLinkList"
            >
              {{ studentwork.fileName }}

              <ul class="list-inline small mb-0">
                <li class="list-inline-item mx-2">
                  <a
                    :href="studentwork.fileUrl || 'javascript:undefined;'"
                    target="_blank"
                    class="text-secondary"
                    :id="`StudentworkModal-studentwork-download-${idx}`"
                    :disabled="studentwork.c_isLocked"
                    @click.prevent="handleGetStudentwork(studentwork)"
                  >
                    {{
                      studentwork.fileUrl
                        ? '下载'
                        : studentwork.isGeneratingUrl
                        ? '正在生成下载链接'
                        : '生成下载链接'
                    }}
                  </a>
                </li>
                <li class="list-inline-item mx-2">
                  <a
                    href="javascript:undefined;"
                    class="text-secondary"
                    :id="`StudentworkModal-studentwork-delete-${idx}`"
                    :disabled="studentwork.c_isLocked"
                    @click.prevent="handleDeleteStudentwork(studentwork)"
                  >
                    {{ studentwork.isDeleting ? '正在删除' : '删除' }}
                  </a>
                </li>
              </ul>
            </div>
            <!-- <div
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            >
              上传作业的文件名称 A

              <ul class="list-inline small mb-0">
                <li class="list-inline-item mx-2">
                  <a href="#" class="text-secondary"> 下载 </a>
                </li>
                <li class="list-inline-item mx-2">
                  <a href="#" class="text-secondary"> 删除 </a>
                </li>
              </ul>
            </div>
            <div
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            >
              上传作业的文件名称 A

              <ul class="list-inline small mb-0">
                <li class="list-inline-item mx-2">
                  <a href="#" class="text-secondary"> 下载 </a>
                </li>
                <li class="list-inline-item mx-2">
                  <a href="#" class="text-secondary"> 删除 </a>
                </li>
              </ul>
            </div> -->
          </div>
        </div>
        <div class="modal-footer">
          <input
            type="file"
            multiple
            class="form-control-file d-none"
            id="exampleFormControl-studentwork"
            @change="handleChangeFileStudentwork"
            ref="filesStudentwork"
          />
          <div class="progress flex-grow-1" v-if="isUploading">
            <div
              class="progress-bar progress-bar-striped progress-bar-animated"
              role="progressbar"
              :aria-valuenow="c_uploadProgress"
              aria-valuemin="0"
              aria-valuemax="100"
              :style="`width: ${c_uploadProgress}%`"
            ></div>
          </div>
          <button
            type="button"
            class="btn btn-primary"
            id="StudentworkModal-handleClickUpload"
            :disabled="c_isUploadDisabled"
            @click.prevent="handleClickUpload"
          >
            {{ isUploading ? '正在上传...' : '上传作业' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { StudentworkMixin } from '@/mixins/Studentwork';

export default {
  name: 'StudentworkModal',

  mixins: [StudentworkMixin],

  props: {
    p_id: {
      type: String,
      default: () => 'studentwork-modal',
    },
  },

  data: () => {
    return {
      isUploading: false,

      filesStudentwork: [],
    };
  },

  computed: {
    ...mapGetters('Mixins/Studentwork', {
      mg_assignmentAttachmentLinkList: 'assignmentAttachmentLinkList',
      mg_isAssignmentAttachmentFull: 'isAssignmentAttachmentFull',
    }),

    c_isUploadDisabled() {
      return this.isUploading || this.mg_isAssignmentAttachmentFull;
    },

    c_qtyUploadingFile() {
      return this.filesStudentwork.length;
    },

    c_uploadProgress() {
      return Math.round(this.idxUploadingFile / this.c_qtyUploadingFile) * 100;
    },
  },

  methods: {
    handleClickUpload() {
      this.$refs.filesStudentwork.click();
    },

    async _handleUploadStudentwork() {
      if (this.filesStudentwork && this.filesStudentwork.length) {
        this.isUploading = true;
        await this.uploadStudentwork(this.filesStudentwork);
        this.isUploading = false;
      }
    },

    async handleChangeFileStudentwork() {
      this.filesStudentwork = this.$refs.filesStudentwork.files;
      await this._handleUploadStudentwork();
    },

    async handleDropUpload(evt) {
      this.filesStudentwork = evt.dataTransfer && evt.dataTransfer.files;
      await this._handleUploadStudentwork();
    },

    async handleGetStudentwork(studentwork) {
      if (studentwork.fileUrl) {
        window.open(studentwork.fileUrl, '_blank');
      } else {
        await this.getStudentwork(studentwork);
      }
    },

    async handleDeleteStudentwork(studentwork) {
      await this.deleteStudentwork(studentwork);
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
